import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#252525",
    "col1l": "#666666",
    "col1n": "#434343",
    "col1s": "#121212",
    "col2d": "#E0E0E0",
    "col2n": "#FFFFFF",
    "col2s": "#C2C2C2"
}
function ObjToy040({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M30.45 33.3q1.8-9.2 6.3-17.4Q29.85 8.65 26 0L6.35 2.4 0 18.85q3.7 5.45 3.35 5.35 2.5 2.1 4.35 7.95l2.45 3.65q10.15-3.25 20.3-2.5z"
                    id="ObjToy040__Symbol_128_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    fillOpacity={0.6}
                    d="M146.3 286.85q-8.225-5.725-16.45-7.95l2.7 21.85 13.75-13.9m-16.45-7.95q4.576-2.824 5.7-7.95l-19.65 2.4 13.95 5.55z"
                    id="ObjToy040__Symbol_91_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M132.55 300.75l7.45 3.5 6.3-17.4-13.75 13.9m13.75-13.9l-10.75-15.9-5.7 7.95 16.45 7.95z"
                    id="ObjToy040__Symbol_91_0_Layer0_1_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M0 17.25q2.15 8.1 6.6 16.15 8.1-2.75 12.85-6L.25 17.3 0 17.25m.25.05l16.5-11.75L2.8 0 .25 17.3z"
                    id="ObjToy040__Symbol_79_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M3.55.8L0 0l3.05 5.1.05.05 2.9 4.9V10l4.15 6.95L3.55.8m26.9 13.65L23 10.95l-12.85 6 20.3-2.5z"
                    id="ObjToy040__Symbol_61_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M7.4 21.7q.2 1.15 1.4 1.75 1.25.6 2.3.05 1-.55 1.85-2.3.9-1.75.7-2.9-.2-1.15-1.4-1.75Q11 15.9 10 16.5q-1.05.55-1.9 2.3-.85 1.75-.7 2.9m1.45-.3q.05-.7.65-1.95.6-1.2 1.1-1.65.55-.45 1.1-.15.55.25.5.95 0 .7-.65 1.9-.6 1.25-1.1 1.65-.55.45-1.05.2-.55-.3-.55-.95M6.7 13.8q-.5-.3-1-.3-.55-.05-1 .1-.45.15-.75.45-.35.25-.5.6-.15.3-.1.55.05.25.35.4.25.1.45.05.25-.05.5-.4.35-.4.7-.45.35-.1.8.1.45.2.6.6.15.4-.1.85-.2.4-.55.65-.4.15-1.5.3-1.45.15-2.2.5-.7.3-1 .85-.2.4-.1.65.15.3.55.5l3.35 1.6q.3.15.5.1.25-.05.35-.35.15-.25.1-.5-.1-.25-.4-.4L3.15 19q.3-.25 1.45-.35.45-.05.7-.1 1.25-.2 1.85-.5.55-.35.9-1.05.45-.95.1-1.8-.35-.9-1.45-1.4M1.5 6.1q.35-.25.7-.2.3.1.5.45t.2.75q-.05.4-.4 1.35-.5 1.25-.6 2-.1.75.2 1.2.15.35.4.35.2.05.55-.2l2.45-2q.2-.15.25-.4.1-.2-.05-.45-.15-.25-.35-.25-.15-.05-.4.1l-1.9 1.55q-.05-.3.35-1.3.15-.4.2-.65.45-1.1.45-1.7 0-.6-.3-1.2-.45-.8-1.2-.9-.75-.1-1.55.55-.4.35-.65.7-.2.4-.3.9-.05.4-.05.8.05.4.2.65.15.25.35.35.2.05.4-.15.25-.15.25-.35.05-.2-.05-.55-.1-.45-.05-.8.1-.35.4-.6M10.85.3Q10.7.15 10.3.25H10.15Q9.75.3 9.5.3 9.3.25 9.1.15q-.2-.1-.25-.1-.05-.05-.2 0-.1 0-.2.05-.2.1-.2.15 0 .1.15.15l.65.35-2.6 1.3q-.2.15-.25.25 0 .1.2.25.15.1.4.05.2 0 .4-.15l3.6-1.8q.2-.1.2-.2T10.85.3m3.1 1.75q0-.3-.6-.65-.6-.3-1.25-.3t-1.2.3q-.3.15-.45.3-.05.15 0 .35-.45-.05-.85 0-.35.05-.75.25-.65.35-.65.7 0 .4.65.7.65.35 1.35.35.75.05 1.4-.3.35-.2.5-.4.1-.2 0-.45.35.05.7 0 .3-.05.6-.2.55-.3.55-.65m-3.65.5q.35 0 .65.1.25.15.2.35 0 .15-.3.35-.3.15-.65.15-.35 0-.6-.15-.3-.15-.3-.3 0-.2.35-.35.3-.15.65-.15m1.3-.8q.25-.1.5-.1.3 0 .55.15.25.1.25.25t-.25.25q-.25.15-.55.15-.25 0-.5-.15-.3-.1-.3-.25.05-.15.3-.3M23.85 24.1q-.4-1.25-.95-1.5-.5-.3-1.15.45-.55.7-.7 1.6-.15.9.15 1.75.25.75.7.85.45.1.9-.5.25-.25.35-.55.15-.3.2-.65.2.7.2 1.2-.05.55-.3.85-.25.3-.55.2 0-.05-.05 0-.1-.1-.2-.05t-.15.15q-.15.15-.2.4-.05.2.05.4.1.4.5.4.4-.05.8-.55.65-.8.75-1.95.1-1.15-.35-2.5m-1.8-.2q.25-.3.45-.25.25.1.4.55.15.4.1.85-.1.4-.3.65-.25.35-.5.25-.2-.05-.35-.45-.15-.45-.1-.9.05-.4.3-.7m1.05-5.55q-.25-.25-.7-.45l-2.75-1.25h-.05q-.9-.4-1.25-.35-.35.05-.5.25-.15.15-.1.45l.3 2.25-.8.15q-.35.05-.5.2-.15.25-.1.55.05.3.2.45.25.15.6.1l.8-.15.05.35q.05.25.2.4.15.1.4.1.3-.05.4-.25.1-.15.05-.4v-.35l3.25-.45q.45-.1.65-.3.2-.25.15-.65-.05-.35-.3-.65m-4 .8l-.25-1.8 3.1 1.4-2.85.4m2.15-7.35l-.05-.35q-.1-.15-.2-.2-.15-.05-.3-.05-.25.05-.35.2-.1.15-.05.4l.15 1.15-3.95.55q-.35.05-.5.25-.15.2-.1.55.05.3.25.45.2.1.55.1l5.5-.8q.25-.05.4-.25.1-.15.1-.4-.1-.35-.45-.55h-.1q-.05 0-.1-.05-.45-.2-.55-.45-.15-.2-.25-.55m.15-7.3q-.15-.4-.4-.7-.25-.25-.7-.4-.35-.15-.6-.1-.25.05-.4.35l-.95 1.7q-.3.5-.2.85.1.3.3.55.25.2.55.3l2.25.85.25.75q.1.35.3.55.2.2.5.35.35.1.5 0 .1-.1 0-.4l-.25-.75.35.1q.3.1.4.05.1-.05 0-.3-.05-.25-.2-.4-.2-.2-.5-.3l-.3-.1-.9-2.95m-1.15-.05L21 7l-1.8-.65 1.05-1.9z"
                    id="ObjToy040__Symbol_41_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M4.95.95Q4.5.4 3.5.15T1.85.1q-.7.3-.9 1-.15.4 0 .65.1.3.45.6-.5.1-.85.35-.3.25-.45.7-.25.8.25 1.4.45.6 1.55.9 1.1.3 1.85 0 .7-.3.95-1.1.15-.4 0-.8t-.55-.7q.45-.05.7-.3.25-.2.35-.6.25-.7-.25-1.25m-2.4.1q.3-.15.7-.05.45.15.6.4.25.2.15.5-.1.35-.35.45-.35.1-.75-.05-.45-.1-.6-.35-.25-.2-.15-.55.1-.25.4-.35M1.4 3.75q.15-.4.45-.55.35-.15.8-.05.45.15.65.45.2.3.1.65-.1.4-.45.55-.35.15-.8 0-.45-.1-.65-.4-.2-.25-.1-.65z"
                    id="ObjToy040__Symbol_9_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2s}
                    d="M6 2.2q.4-.45-.2-.65-.55-.2-2.05-.2-1.35.05-2.25.2-.95.2-1.35.6-.3.3.05.55.35.2 1.25.2.85 0 1.55-.2.65-.2 1-.5.1-.1.15-.2-.05-.15-.15-.2.75 0 1 .1.3.1.15.25t-.65.25q-.1 0-.1.05-.2 0-.3.05-.1.05-.15.1-.1.1.05.15.05.05.3.05.45 0 .95-.2.5-.15.75-.4m-2.9-.3q.2.1.05.2-.15.15-.5.25t-.8.1q-.5 0-.7-.1-.2-.05-.05-.2.15-.15.5-.25.4-.1.9-.1.45 0 .6.1M7.2.75q.1-.1-.1-.2-.05.05-.05 0H7Q6.75.5 6.75.4l.1-.2.05-.1q.05-.05-.05-.05Q6.8 0 6.65 0q-.15 0-.3.05l-.2.1-.3.4H2.5q-.2.1-.3.2-.1.1 0 .15.1.05.35.05h4.1q.2 0 .3-.05.2-.05.25-.15z"
                    id="ObjToy040__Symbol_1_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjToy040__Symbol_128_0_Layer0_0_FILL"
                transform="translate(109.55 270.95)"
                id="ObjToy040__col1n"
            />
            <g id="ObjToy040__col1l">
                <use xlinkHref="#ObjToy040__Symbol_91_0_Layer0_0_FILL" />
                <use xlinkHref="#ObjToy040__Symbol_91_0_Layer0_1_FILL" />
            </g>
            <use
                xlinkHref="#ObjToy040__Symbol_79_0_Layer0_0_FILL"
                transform="translate(113.1 273.35)"
                id="ObjToy040__col1d"
            />
            <use
                xlinkHref="#ObjToy040__Symbol_61_0_Layer0_0_FILL"
                transform="translate(109.55 289.8)"
                id="ObjToy040__col1s"
            />
            <use
                xlinkHref="#ObjToy040__Symbol_41_0_Layer0_0_FILL"
                transform="translate(116.75 272.55)"
                id="ObjToy040__col2n"
            />
            <use
                xlinkHref="#ObjToy040__Symbol_9_0_Layer0_0_FILL"
                transform="translate(118.8 297.45)"
                id="ObjToy040__col2d"
            />
            <use
                xlinkHref="#ObjToy040__Symbol_1_0_Layer0_0_FILL"
                transform="translate(127.25 302.3)"
                id="ObjToy040__col2s"
            />
        </g></g>
    )
}
export default ObjToy040
